// Pages/SupporterUpload/SupporterUpload.js
import React, { useState } from "react";
import "./UploadImage.css";
import { useConfig } from "../../context/ConfigContext";

export default function SupporterUpload() {
  const { config } = useConfig();
  const apiurl = config.REACT_APP_SUPPORTER_UPLOAD_URL;

  const [name, setName] = useState("");
  const [caption, setCaption] = useState("");
  const [files, setFiles] = useState([]);           
  const [previews, setPreviews] = useState([]);     
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const onFileChange = (e) => {
    const selected = Array.from(e.target.files || []);
    if (!selected.length) return;

    setFiles(selected);

    previews.forEach((p) => URL.revokeObjectURL(p));
    const urls = selected.map((f) => URL.createObjectURL(f));
    setPreviews(urls);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!files.length) {
      setError("Please choose at least one image to upload.");
      return;
    }

    try {
      setSubmitting(true);

      const formData = new FormData();
      formData.append("name", name);
      formData.append("caption", caption);

      files.forEach((file) => {
        formData.append("images", file);
      });

      const res = await fetch(apiurl, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (!res.ok || !data.success) {
        throw new Error(data.error || "Upload failed");
      }

      setMessage(
        "Thank you! Your photos will appear once approved by an admin."
      );
      setFiles([]);
      previews.forEach((p) => URL.revokeObjectURL(p));
      setPreviews([]);
      setName("");
      setCaption("");
    } catch (err) {
      console.error(err);
      setError(err.message || "Upload failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="supporter-upload">
      <div className="supporter-card">
        <h1>Share Your Match Photos 📸</h1>
        <p className="muted">
          Upload your photos from the Beth Branson Memorial Match.  
          Once approved by our admin team, they’ll appear in the gallery
          with a caption like: <strong>“Uploaded by a supporter”</strong>.
        </p>

        <form onSubmit={onSubmit} className="supporter-form">
          <label className="field">
            <span>Your name (optional)</span>
            <input
              className="input"
              type="text"
              placeholder="e.g. Sam, Bridgwater"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </label>

          <label className="field">
            <span>Upload photos</span>
            <div className="upload-box">
              <input
                type="file"
                accept="image/*"
                multiple         // ← key bit
                onChange={onFileChange}
              />
            </div>
            <p className="hint small">
              You can select multiple images. Max size ~5MB each. JPEG or PNG recommended.
            </p>
          </label>

          {previews.length > 0 && (
            <div className="preview-grid">
              <p className="small">Preview ({previews.length} images)</p>
              <div className="preview-list">
                {previews.map((src, idx) => (
                  <figure key={idx} className="preview-item">
                    <img src={src} alt={`Preview ${idx + 1}`} />
                    <figcaption className="small muted">
                      Uploaded by a supporter
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          )}

          {error && <p className="error small">{error}</p>}
          {message && <p className="success small">{message}</p>}

          <button className="btn primary" disabled={submitting}>
            {submitting ? "Uploading…" : "Submit Photos"}
          </button>
        </form>
      </div>
    </section>
  );
}